import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,

  prepareFilter,
  filterFields,
  filterInitialValues,
} from './YearUtils';


const YearPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.shifts }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/dorms")) {
    const temp = menuList.find(q => q.url == "/dorms")
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          {
            <Redirect
              // exact={true}
              from="/terms/semesters"
              to="/terms/years"
            />

          }
          {
            <Redirect
              // exact={true}
              from="/terms/terms"
              to="/terms/years"
            />
          }
          <ContentRoute path="/terms/years/new"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/terms/years" api="api/year" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/terms/years/:id/edit"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/terms/years" api="api/year" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/terms/years"
            render={props => <ObjectsPage isFullAccess={isFullAccess} basePath="/terms/years" api="api/year" currentState={currentState}
              columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>

  )
}

export default YearPage



